<template>
    <NuxtLayout name="default">
        <div class="flex flex-col w-full px-6 pt-8">
            <layout-maintenance class="mt-12 mb-12" />

            <div class="flex justify-center w-full mx-auto flex-1 auth-width">
                <slot />
            </div>

            <layout-footer />
        </div>
    </NuxtLayout>
</template>
